import React from 'react';

/* This file has been generated via the 'icons' script */

export const IconAlertOctagon = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.153 1.293A1 1 0 017.86 1h8.28a1 1 0 01.707.293l5.86 5.86A1 1 0 0123 7.86v8.28a1 1 0 01-.293.707l-5.86 5.86a1 1 0 01-.707.293H7.86a1 1 0 01-.707-.293l-5.86-5.86A1 1 0 011 16.14V7.86a1 1 0 01.293-.707l5.86-5.86zM8.274 3L3 8.274v7.452L8.274 21h7.452L21 15.726V8.274L15.726 3H8.274zM11 16a1 1 0 011-1h.01a1 1 0 110 2H12a1 1 0 01-1-1zm2-8a1 1 0 10-2 0v4a1 1 0 102 0V8z'
    />
  </svg>
);

export const IconAlertTriangle = (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z'
    />
  </svg>
);

export const IconArrowDownCircle = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 23C5.92487 23 1 18.0751 1 12C0.999999 5.92487 5.92487 1 12 1C18.0751 0.999999 23 5.92487 23 12C23 18.0751 18.0751 23 12 23Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L12 14.5858L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 17C11.4477 17 11 16.5523 11 16L11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8L13 16C13 16.5523 12.5523 17 12 17Z'
    />
  </svg>
);

export const IconArrowDown = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 3a1 1 0 10-2 0v15.586l-7.293-7.293a1 1 0 00-1.414 1.414l9 9a1 1 0 001.414 0l9-9a1 1 0 00-1.414-1.414L13 18.586V3z'
    />
  </svg>
);

export const IconArrowLeftCircle = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02943 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM0.999998 12C0.999999 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 0.999997 18.0751 0.999998 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.7071 7.2929C13.0976 7.68342 13.0976 8.31659 12.7071 8.70711L9.41421 12L12.7071 15.2929C13.0976 15.6834 13.0976 16.3166 12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L11.2929 7.2929C11.6834 6.90237 12.3166 6.90237 12.7071 7.2929Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 12C7 11.4477 7.44772 11 8 11L16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13L8 13C7.44771 13 7 12.5523 7 12Z'
    />
  </svg>
);

export const IconArrowLeft = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.707 3.707a1 1 0 00-1.414-1.414l-9 9a1 1 0 000 1.414l9 9a1 1 0 001.414-1.414L5.414 13H21a1 1 0 100-2H5.414l7.293-7.293z'
    />
  </svg>
);

export const IconArrowRightCircle = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 0.999999 12 0.999999C18.0751 1 23 5.92487 23 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L14.5858 12L11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 12C17 12.5523 16.5523 13 16 13L8 13C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11L16 11C16.5523 11 17 11.4477 17 12Z'
    />
  </svg>
);

export const IconArrowRight = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.707 2.293a1 1 0 10-1.414 1.414L18.586 11H3a1 1 0 100 2h15.586l-7.293 7.293a1 1 0 001.414 1.414l9-9a1 1 0 000-1.414l-9-9z'
    />
  </svg>
);

export const IconArrowUpCircle = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 0.999999 18.0751 1 12C1 5.92487 5.92487 0.999999 12 1Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.7071 12.7071C16.3166 13.0976 15.6834 13.0976 15.2929 12.7071L12 9.41421L8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 7C12.5523 7 13 7.44772 13 8L13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16L11 8C11 7.44772 11.4477 7 12 7Z'
    />
  </svg>
);

export const IconArrowUpRightCircle = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 00-7.032 14.618L12.586 10H9a1 1 0 110-2h6a1 1 0 011 1v6a1 1 0 11-2 0v-3.586l-7.618 7.618A9 9 0 1012 3zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'
    />
  </svg>
);

export const IconArrowUpRight = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 4a1 1 0 000 2h9.586L4.293 18.293a1 1 0 101.414 1.414L18 7.414V17a1 1 0 102 0V5a1 1 0 00-1-1H7z'
    />
  </svg>
);

export const IconArrowUp = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.707 2.293a1 1 0 00-1.414 0l-9 9a1 1 0 101.414 1.414L11 5.414V21a1 1 0 102 0V5.414l7.293 7.293a1 1 0 001.414-1.414l-9-9z'
    />
  </svg>
);

export const IconBackInTime = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.605 2.107a10 10 0 11-4.147 18.227 1 1 0 111.108-1.665A8 8 0 106.318 6.375L3.474 9H7a1 1 0 010 2H1a1 1 0 01-1-1V4a1 1 0 012 0v3.64l2.948-2.722a10 10 0 015.657-2.811zM13 7a1 1 0 10-2 0v6a1 1 0 00.553.894l4 2a1 1 0 10.894-1.788L13 12.382V7z'
    />
  </svg>
);

export const IconBellOff = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.707.293A1 1 0 00.293 1.707L5 6.414 4 9V14a2 2 0 01-2 2 1 1 0 100 2h14.586l5.707 5.707a1 1 0 001.414-1.414l-6-6-11.22-11.22-4.78-4.78zM14.586 16L6.168 7.582A6 6 0 006 8.999V14a4 4 0 01-.536 2h9.122zM9.05 3.77A6 6 0 0118 9v4a1 1 0 102 0V9A8 8 0 008.069 2.03a1 1 0 10.982 1.74zm2.084 16.728a1 1 0 00-1.73 1.004 3 3 0 005.19 0 1 1 0 00-1.73-1.004 1 1 0 01-1.73 0z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconBell = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a6 6 0 00-6 6v5a4 4 0 01-.536 2h13.072A4 4 0 0118 14V9a6 6 0 00-6-6zm10 13a2 2 0 01-2-2V9A8 8 0 004 9v5a2 2 0 01-2 2 1 1 0 100 2h20a1 1 0 100-2zM9.768 20.135a1 1 0 011.367.363 1 1 0 001.73 0 1 1 0 011.73 1.004 3 3 0 01-5.19 0 1 1 0 01.363-1.367z'
    />
  </svg>
);

export const IconCalendar = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 2a1 1 0 10-2 0v1H9V2a1 1 0 00-2 0v1H5a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V6a3 3 0 00-3-3h-2V2zM7 6V5H5a1 1 0 00-1 1v3h16V6a1 1 0 00-1-1h-2v1a1 1 0 11-2 0V5H9v1a1 1 0 01-2 0zm13 5H4v9a1 1 0 001 1h14a1 1 0 001-1v-9z'
    />
  </svg>
);

export const IconCamera = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 2a1 1 0 00-.832.445L6.465 5H3a3 3 0 00-3 3v11a3 3 0 003 3h18a3 3 0 003-3V8a3 3 0 00-3-3h-3.465l-1.703-2.555A1 1 0 0015 2H9zM7.832 6.555L9.535 4h4.93l1.703 2.555A1 1 0 0017 7h4a1 1 0 011 1v11a1 1 0 01-1 1H3a1 1 0 01-1-1V8a1 1 0 011-1h4a1 1 0 00.832-.445zM9 13a3 3 0 116 0 3 3 0 01-6 0zm3-5a5 5 0 100 10 5 5 0 000-10z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconCancel = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.382 4.968a9 9 0 0112.65 12.65L6.382 4.968zM4.968 6.382a9 9 0 0012.65 12.65L4.968 6.382zM12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z'
    />
  </svg>
);

export const IconCandy = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 7a5 5 0 100 10 5 5 0 000-10zm-7 5a7 7 0 1114 0 7 7 0 01-14 0z'
      />
      <path d='M8.128.008a1 1 0 01.8.62l2 5a1 1 0 01-1.856.743l-1.396-3.49a5.341 5.341 0 01-.908.724c-.675.41-1.384.427-1.801.437l-.118.003c-.445.017-.54.06-.642.162-.101.102-.145.197-.162.642l-.003.118c-.01.417-.028 1.126-.437 1.801-.195.322-.46.635-.723.908l3.49 1.396a1 1 0 01-.743 1.857l-5-2a1 1 0 01-.224-1.733l.009-.006.033-.026a10.545 10.545 0 00.575-.476c.363-.323.704-.678.873-.956.125-.206.132-.4.151-.936v-.02c.019-.494.061-1.297.747-1.983.686-.686 1.489-.728 1.984-.746l.02-.001c.534-.02.729-.026.935-.151.278-.169.633-.51.956-.873a10.545 10.545 0 00.476-.575L7.19.414l.005-.008c.216-.291.573-.444.933-.398zM15.872 23.992a1 1 0 01-.8-.62l-2-5a1 1 0 011.857-.743l1.395 3.49c.273-.264.586-.53.908-.724.675-.41 1.384-.427 1.801-.437l.118-.003c.445-.016.54-.06.642-.162.101-.101.146-.197.162-.642l.003-.118c.01-.417.028-1.126.437-1.801a5.34 5.34 0 01.723-.908l-3.49-1.396a1 1 0 01.743-1.857l5 2a1 1 0 01.224 1.733l-.009.006-.033.026a9.174 9.174 0 00-.575.476c-.363.323-.704.678-.873.956-.125.206-.132.4-.151.935v.02c-.019.495-.061 1.298-.747 1.984-.686.686-1.489.728-1.984.746l-.02.001c-.534.02-.729.026-.935.151-.278.169-.633.51-.957.873a10.566 10.566 0 00-.475.575l-.026.033-.005.008a1.001 1.001 0 01-.933.398z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.707 7.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414-1.414l8-8a1 1 0 011.414 0z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconCarFront = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.051 5.684A1 1 0 016 5h12a1 1 0 01.949.684L20.72 11H22a1 1 0 110 2h-1v7a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1.5H6V20a1 1 0 01-1 1H4a1 1 0 01-1-1v-7H2a1 1 0 110-2h1.28L5.05 5.684zM5 13v3.5h14V13H5zm13.613-2H5.387l1.334-4h10.558l1.334 4zM6 15a1 1 0 011-1h1a1 1 0 110 2H7a1 1 0 01-1-1zm9 0a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconCarPlus = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 5C4.75123 5 4.5114 5.09272 4.32733 5.26006L4.32601 5.26126L4.32388 5.2632L4.31726 5.26927L4.29482 5.29C4.27588 5.30758 4.24911 5.33261 4.2154 5.36462C4.14802 5.42859 4.05271 5.52058 3.93664 5.63664C3.70498 5.8683 3.38812 6.19837 3.04431 6.59507C2.37201 7.3708 1.53424 8.47181 1.07152 9.62861C0.6416 10.7034 0.376849 11.7667 0.219419 12.5539C0.140286 12.9496 0.0872753 13.2805 0.0538006 13.5148C0.0370476 13.6321 0.0251431 13.7255 0.0172794 13.791C0.0133465 13.8238 0.0104209 13.8496 0.00840223 13.868L0.00604093 13.89L0.00534618 13.8967L0.0049628 13.9005C0.00165635 13.9336 0 13.9668 0 14V15C0 15.5523 0.447715 16 1 16H2.17071C2.58254 17.1652 3.69378 18 5 18C6.30622 18 7.41746 17.1652 7.82929 16H15.1707C15.5825 17.1652 16.6938 18 18 18C19.3062 18 20.4175 17.1652 20.8293 16H23C23.5523 16 24 15.5519 24 14.9996V12C24 11.0949 23.5184 10.5188 23.0547 10.2096C22.8367 10.0643 22.6257 9.97738 22.4725 9.92632C22.3943 9.90025 22.3267 9.88204 22.2746 9.86964C22.2484 9.86341 22.2258 9.85856 22.2073 9.85487L22.1827 9.85014L22.1727 9.84836L22.1684 9.84761L22.1644 9.84694L17.5596 9.07947L15.55 6.4L15.5484 6.39781L15.5464 6.39523L15.5416 6.38897L15.5286 6.37211C15.5183 6.35901 15.5049 6.34223 15.4885 6.32229C15.4559 6.2825 15.4108 6.22963 15.3543 6.16803C15.2425 6.04602 15.0801 5.88348 14.8747 5.71913C14.4843 5.40679 13.828 5 13 5H5ZM20.8293 14H22V12C22 11.9592 21.995 11.936 21.9923 11.9259C21.9896 11.9159 21.9863 11.9103 21.9863 11.9103C21.9845 11.9074 21.9756 11.8939 21.9453 11.8737C21.9133 11.8524 21.8743 11.8351 21.84 11.8237C21.8295 11.8202 21.8213 11.8178 21.8163 11.8165L16.8356 10.9864C16.5819 10.9441 16.3543 10.8057 16.2 10.6L13.9536 7.60486L13.9431 7.59177C13.9309 7.57687 13.9095 7.55162 13.88 7.51947C13.82 7.45398 13.7324 7.36652 13.6253 7.28087C13.3907 7.09321 13.172 7 13 7H5.40196L5.35086 7.05086C5.14502 7.2567 4.86188 7.55163 4.55569 7.90493C3.92799 8.6292 3.26576 9.52819 2.92848 10.3714C2.5584 11.2966 2.32315 12.2333 2.18058 12.9461C2.10971 13.3004 2.06272 13.5945 2.0337 13.7977C2.02172 13.8815 2.01283 13.9497 2.00661 14H2.17071C2.58254 12.8348 3.69378 12 5 12C6.30622 12 7.41746 12.8348 7.82929 14H15.1707C15.5825 12.8348 16.6938 12 18 12C19.3062 12 20.4175 12.8348 20.8293 14ZM5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14ZM18 14C17.4477 14 17 14.4477 17 15C17 15.5523 17.4477 16 18 16C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21 0C21.5523 5.96046e-08 22 0.447715 22 1V2H23C23.5523 2 24 2.44772 24 3C24 3.55229 23.5523 4 23 4L22 4V5C22 5.55228 21.5523 6 21 6C20.4477 6 20 5.55228 20 5L20 4H19C18.4477 4 18 3.55228 18 3C18 2.44772 18.4477 2 19 2H20V1C20 0.447715 20.4477 0 21 0Z'
    />
  </svg>
);

export const IconCarSide = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 5a1 1 0 00-.673.26l-.001.001-.002.002-.007.006-.022.021a15.146 15.146 0 00-.358.347c-.232.231-.549.561-.893.958-.672.776-1.51 1.877-1.972 3.034a16.985 16.985 0 00-.853 2.925 17.733 17.733 0 00-.21 1.314l-.003.022v.007l-.001.003A1 1 0 000 14v1a1 1 0 001 1h1.17a3.001 3.001 0 005.66 0h7.34a3.001 3.001 0 005.66 0H23a1 1 0 001-1v-3c0-.905-.482-1.481-.945-1.79a2.456 2.456 0 00-.848-.355l-.024-.005-.01-.002h-.005l-.004-.001-4.604-.768L15.55 6.4l-.002-.002-.002-.003-.004-.006-.013-.017a2.91 2.91 0 00-.175-.204 4.305 4.305 0 00-.48-.449C14.485 5.407 13.829 5 13 5H5zm15.83 9H22v-2a.288.288 0 00-.008-.074c-.002-.01-.006-.016-.006-.016a.134.134 0 00-.04-.036.458.458 0 00-.13-.058l-4.98-.83a1 1 0 01-.636-.386l-2.246-2.995-.01-.013a2.3 2.3 0 00-.318-.31c-.235-.189-.454-.282-.626-.282H5.402l-.051.05c-.206.207-.49.502-.795.855-.628.724-1.29 1.623-1.628 2.466-.37.926-.605 1.862-.747 2.575A15.709 15.709 0 002.007 14h.164a3.001 3.001 0 015.658 0h7.342a3.001 3.001 0 015.658 0zM5 14a1 1 0 100 2 1 1 0 000-2zm13 0a1 1 0 100 2 1 1 0 000-2z'
    />
  </svg>
);

export const IconCashMore = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 13V7C3.65685 7 5 5.65685 5 4H17C17 5.65685 18.3431 7 20 7V9.10134C20.7424 9.20413 21.421 9.38131 22 9.61539V4.75C22 3.10996 20.5272 2 19 2H3C1.47275 2 0 3.10996 0 4.75V15.25C0 16.89 1.47275 18 3 18H12V16H5C5 14.3431 3.65685 13 2 13ZM3 4C2.31811 4 2 4.45704 2 4.75V5C2.55228 5 3 4.55228 3 4ZM20 5V4.75C20 4.45704 19.6819 4 19 4C19 4.55228 19.4477 5 20 5ZM2 15.25V15C2.55228 15 3 15.4477 3 16C2.31811 16 2 15.543 2 15.25Z'
    />
    <path d='M11 6C13.0395 6 14.7226 7.52643 14.969 9.49921C14.1848 9.72603 13.4884 10.0203 12.9675 10.361C12.9888 10.2439 13 10.1233 13 10C13 8.89543 12.1046 8 11 8C9.89543 8 9 8.89543 9 10C9 11.1046 9.89543 12 11 12C11.3643 12 11.7058 11.9026 12 11.7324V13.874C11.6804 13.9562 11.3453 14 11 14C8.79086 14 7 12.2091 7 10C7 7.79086 8.79086 6 11 6Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.5 10C21.5376 10 24 11.3431 24 13V20.5C24 21.7184 23.1228 22.6112 22.1676 23.1419C21.1785 23.6914 19.8799 24 18.5 24C17.1201 24 15.8215 23.6914 14.8324 23.1419C13.8772 22.6112 13 21.7184 13 20.5V13C13 11.3431 15.4624 10 18.5 10ZM21.4314 12.6345C21.7155 12.7895 21.8642 12.9171 21.9401 13C21.8642 13.0829 21.7155 13.2105 21.4314 13.3655C20.7828 13.7193 19.7501 14 18.5 14C17.2499 14 16.2172 13.7193 15.5686 13.3655C15.2845 13.2105 15.1358 13.0829 15.0599 13C15.1358 12.9171 15.2845 12.7895 15.5686 12.6345C16.2172 12.2807 17.2499 12 18.5 12C19.7501 12 20.7828 12.2807 21.4314 12.6345ZM14.986 12.8955L14.9866 12.8977C14.9866 12.8977 14.9878 12.9007 14.9889 12.903C14.9877 12.899 14.986 12.8955 14.986 12.8955ZM22 15.3143V16.5C22 16.6623 21.8698 17.0195 21.1963 17.3936C20.5567 17.7489 19.6054 18 18.5 18C17.3946 18 16.4433 17.7489 15.8037 17.3936C15.1302 17.0195 15 16.6623 15 16.5V15.3143C15.9509 15.7426 17.1704 16 18.5 16C19.8296 16 21.0491 15.7426 22 15.3143ZM22 20.5V19.2312C21.034 19.7247 19.8032 20 18.5 20C17.1968 20 15.966 19.7247 15 19.2312V20.5C15 20.6623 15.1302 21.0195 15.8037 21.3936C16.4433 21.7489 17.3946 22 18.5 22C19.6054 22 20.5567 21.7489 21.1963 21.3936C21.8698 21.0195 22 20.6623 22 20.5Z'
    />
  </svg>
);

export const IconCash = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6.75C2 6.457 2.318 6 3 6a1 1 0 01-1 1v-.25zM2 9v6a3 3 0 013 3h14a3 3 0 013-3V9a3 3 0 01-3-3H5a3 3 0 01-3 3zm20-2.25V7a1 1 0 01-1-1c.682 0 1 .457 1 .75zM21 18a1 1 0 011-1v.25c0 .293-.318.75-1 .75zM2 17v.25c0 .293.318.75 1 .75a1 1 0 00-1-1zM3 4C1.473 4 0 5.11 0 6.75v10.5C0 18.89 1.473 20 3 20h18c1.527 0 3-1.11 3-2.75V6.75C24 5.11 22.527 4 21 4H3zm8 8a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z'
    />
  </svg>
);

export const IconChartBar = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 3a1 1 0 10-2 0v18a1 1 0 102 0V3zm-6 8a1 1 0 10-2 0v10a1 1 0 102 0V11zM9 6a1 1 0 011 1v14a1 1 0 11-2 0V7a1 1 0 011-1zm-5 9a1 1 0 10-2 0v6a1 1 0 102 0v-6z'
    />
  </svg>
);

export const IconChartPie = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1A11 11 0 0012 1zm1 10V3.056A9 9 0 0120.944 11H13zM8.4 3.747a1 1 0 00-.8-1.834A11 11 0 1022.131 16.28a1 1 0 10-1.842-.778A9 9 0 118.4 3.747z'
    />
  </svg>
);

export const IconCheck = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.707 4.293a1 1 0 010 1.414l-13 13a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 16.586 21.293 4.293a1 1 0 011.414 0z'
    />
  </svg>
);

export const IconChevronDown = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.293 8.293a1 1 0 011.414 0L12 13.586l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z'
    />
  </svg>
);

export const IconChevronLeft = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.707 5.293a1 1 0 010 1.414L10.414 12l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z'
    />
  </svg>
);

export const IconChevronRight = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.293 18.707a1 1 0 010-1.414L13.586 12 8.293 6.707a1 1 0 011.414-1.414l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0z'
    />
  </svg>
);

export const IconChevronUpDown = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.495 5.21a.714.714 0 0 1 1.01 0l4.286 4.285a.714.714 0 0 1-1.01 1.01L12 6.725l-3.78 3.78a.714.714 0 0 1-1.01-1.01l4.285-4.286zM12.505 18.505a.714.714 0 0 1-1.01 0L7.209 14.22a.714.714 0 0 1 1.01-1.01L12 16.99l3.78-3.78a.714.714 0 0 1 1.01 1.01l-4.285 4.286z'
    />
  </svg>
);

export const IconChevronUp = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.293 8.293a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 01-1.414-1.414l6-6z'
    />
  </svg>
);

export const IconClock = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 5a1 1 0 011 1v5.382l3.447 1.724a1 1 0 11-.894 1.788l-4-2A1 1 0 0111 12V6a1 1 0 011-1z'
    />
  </svg>
);

export const IconCoffee = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 1a1 1 0 00-2 0v3a1 1 0 002 0V1zM1 8a1 1 0 011-1h17a5 5 0 110 10 5 5 0 01-5 5H6a5 5 0 01-5-5V8zm18 7V9a3 3 0 010 6zm-2-6v8a3 3 0 01-3 3H6a3 3 0 01-3-3V9h14zm-7-9a1 1 0 011 1v3a1 1 0 11-2 0V1a1 1 0 011-1zm5 1a1 1 0 10-2 0v3a1 1 0 102 0V1z'
    />
  </svg>
);

export const IconCopy = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H13C13.2652 3 13.5196 3.10536 13.7071 3.29289C13.8946 3.48043 14 3.73478 14 4V5C14 5.55228 14.4477 6 15 6C15.5523 6 16 5.55228 16 5V4C16 3.20435 15.6839 2.44129 15.1213 1.87868C14.5587 1.31607 13.7956 1 13 1H4C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V13C1 13.7956 1.31607 14.5587 1.87868 15.1213C2.44129 15.6839 3.20435 16 4 16H5C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14H4C3.73478 14 3.48043 13.8946 3.29289 13.7071C3.10536 13.5196 3 13.2652 3 13V4C3 3.73478 3.10536 3.48043 3.29289 3.29289ZM10 11C10 10.4477 10.4477 10 11 10H20C20.5523 10 21 10.4477 21 11V20C21 20.5523 20.5523 21 20 21H11C10.4477 21 10 20.5523 10 20V11ZM11 8C9.34315 8 8 9.34315 8 11V20C8 21.6569 9.34315 23 11 23H20C21.6569 23 23 21.6569 23 20V11C23 9.34315 21.6569 8 20 8H11Z'
    />
  </svg>
);

export const IconCreditCard = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6a1 1 0 011-1h18a1 1 0 011 1v3H2V6zm0 5v7a1 1 0 001 1h18a1 1 0 001-1v-7H2zm1-8a3 3 0 00-3 3v12a3 3 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3H3zm1 11a1 1 0 011-1h7a1 1 0 110 2H5a1 1 0 01-1-1zm14-1a1 1 0 100 2h2a1 1 0 100-2h-2z'
    />
  </svg>
);

export const IconCross = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.707 4.707a1 1 0 00-1.414-1.414L12 10.586 4.707 3.293a1 1 0 00-1.414 1.414L10.586 12l-7.293 7.293a1 1 0 101.414 1.414L12 13.414l7.293 7.293a1 1 0 001.414-1.414L13.414 12l7.293-7.293z'
    />
  </svg>
);

export const IconDirection = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.707 3.12132C12.3165 2.7308 11.6834 2.7308 11.2928 3.12132L3.12126 11.2929C2.73074 11.6834 2.73074 12.3166 3.12126 12.7071L7.00002 16.5859L7.00005 12.9996C7.00009 11.3427 8.34334 9.99999 9.99998 9.99999L14.5858 10L13.2929 8.70711C12.9024 8.31658 12.9024 7.68342 13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289L17.7071 10.2929C18.0976 10.6834 18.0976 11.3166 17.7071 11.7071L14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929L14.5858 12L9.99998 12C9.4476 12 9.00006 12.4476 9.00005 12.9997L9 18.5858L11.2928 20.8787C11.6834 21.2692 12.3165 21.2692 12.707 20.8787L20.8786 12.7071C21.2691 12.3166 21.2691 11.6834 20.8786 11.2929L12.707 3.12132ZM9.87862 1.70711C11.0502 0.535538 12.9497 0.535536 14.1213 1.70711L22.2928 9.87868C23.4644 11.0503 23.4644 12.9497 22.2928 14.1213L14.1213 22.2929C12.9497 23.4645 11.0502 23.4645 9.87862 22.2929L1.70705 14.1213C0.535477 12.9498 0.535475 11.0503 1.70705 9.87868L9.87862 1.70711Z'
    />
  </svg>
);

export const IconDownload = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 14a1 1 0 011 1v4a1 1 0 001 1h14a1 1 0 001-1v-4a1 1 0 112 0v4a3 3 0 01-3 3H5a3 3 0 01-3-3v-4a1 1 0 011-1z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.293 9.293a1 1 0 011.414 0L12 13.586l4.293-4.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 2a1 1 0 011 1v12a1 1 0 11-2 0V3a1 1 0 011-1z'
    />
  </svg>
);

export const IconEmojiAngry = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm7.476 2.195c.798-.578 2-1.185 3.524-1.185s2.726.607 3.524 1.185a6.94 6.94 0 011.171 1.075l.07.085.021.027.008.01.002.003.002.002v.001a1 1 0 01-1.593 1.208L15.2 16.6a3.616 3.616 0 00-.194-.218 4.934 4.934 0 00-.655-.567c-.577-.417-1.375-.805-2.35-.805-.977 0-1.775.388-2.352.805a4.935 4.935 0 00-.815.744L8.8 16.6l-.005.006a1 1 0 01-1.593-1.208v-.001l.002-.002.002-.003.008-.01.021-.027.07-.085c.059-.07.142-.164.248-.275.212-.22.522-.51.923-.8zm-.029-4.028A1 1 0 009 12h.01a1 1 0 001-1 .998.998 0 00.545-1.832l-3-2a1 1 0 00-1.11 1.664l2.002 1.335zm7.11-.004l1.998-1.33a1 1 0 00-1.11-1.665l-3 2A1 1 0 0014 11a1 1 0 001 1h.01a1 1 0 00.548-1.837z'
    />
  </svg>
);

export const IconEmojiMistake = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.997 0a1 1 0 01.744.33l2.483 2.758A10.927 10.927 0 0113 2c6.075 0 11 4.925 11 11s-4.925 11-11 11S2 19.075 2 13c0-.65.057-1.289.165-1.91a5 5 0 01-.72-7.635L4.255.331A1 1 0 014.997 0zm4.907 5.995a5 5 0 00-.44-1.274A8.925 8.925 0 0113 4a9 9 0 11-8.932 7.884 4.997 4.997 0 005.552-3 5 5 0 00.284-2.889zm-4.906-3.5L2.916 4.811a3 3 0 104.168 0L4.998 2.496zm6.45 13.61a1 1 0 00-.895 0l-2 1a1 1 0 10.894 1.79L11 18.117l1.553.776a1 1 0 00.894 0L15 18.118l1.553.776a1 1 0 10.894-1.788l-2-1a1 1 0 00-.894 0L13 16.882l-1.553-.776zM9 12a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm7-1a1 1 0 100 2h.01a1 1 0 100-2H16z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconEmojiSmile = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM7.4 13.2a1 1 0 011.397.196l.005.006.033.041a4.952 4.952 0 00.815.748c.578.42 1.376.809 2.35.809.975 0 1.772-.39 2.35-.809a4.951 4.951 0 00.815-.748l.034-.041.004-.006A1 1 0 0116.8 14.6l-.001.001-.001.002-.003.004-.007.009-.021.027-.07.086a6.944 6.944 0 01-1.171 1.08c-.798.58-2 1.191-3.526 1.191-1.525 0-2.728-.61-3.526-1.191a6.942 6.942 0 01-1.17-1.08 4.174 4.174 0 01-.07-.086l-.022-.027-.007-.01-.003-.003V14.6L7.2 14.6a1 1 0 01.2-1.4zM8 9a1 1 0 011-1h.01a1 1 0 110 2H9a1 1 0 01-1-1zm7-1a1 1 0 100 2h.01a1 1 0 100-2H15z'
    />
  </svg>
);

export const IconEuro = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.41 9c1.016-3.58 3.797-6 6.84-6 1.957 0 3.774.972 5.114 2.629a1 1 0 001.555-1.258C18.265 2.326 15.909 1 13.249 1 8.896 1 5.433 4.478 4.352 9H3a1 1 0 100 2h1.038a13.043 13.043 0 000 2H3a1 1 0 100 2h1.351c1.08 4.522 4.544 8 8.899 8 2.658 0 5.015-1.326 6.669-3.371a1 1 0 10-1.555-1.258C17.024 20.028 15.207 21 13.25 21c-3.043 0-5.824-2.42-6.84-6H13a1 1 0 100-2H6.043a11.442 11.442 0 010-2H13a1 1 0 100-2H6.41z'
    />
  </svg>
);

export const IconEyeClose = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.70711 0.292893C1.31658 -0.0976311 0.683418 -0.0976311 0.292893 0.292893C-0.097631 0.683417 -0.097631 1.31658 0.292893 1.70711L4.54478 5.959C2.74696 7.51586 1.24594 9.3907 0.118695 11.493C-0.0347449 11.7792 -0.0396884 12.122 0.105437 12.4125L1 11.9656C0.105437 12.4125 0.105605 12.4128 0.105789 12.4132L0.106234 12.4141L0.107404 12.4164L0.110862 12.4233L0.122238 12.4456C0.131801 12.4642 0.145322 12.4902 0.162772 12.5232C0.197665 12.5892 0.248308 12.6831 0.31447 12.8008C0.446717 13.0361 0.641416 13.3675 0.896749 13.7632C1.40617 14.5526 2.16346 15.6076 3.15539 16.6664C5.12094 18.7646 8.12676 21 12.039 21L12.0553 20.9999C14.1148 20.9662 16.1179 20.3603 17.8444 19.2586L22.2929 23.7071C22.6834 24.0976 23.3166 24.0976 23.7071 23.7071C24.0976 23.3166 24.0976 22.6834 23.7071 22.2929L18.8906 17.4764C18.8436 17.3843 18.7821 17.299 18.7074 17.2243L14.8778 13.3919L14.8708 13.3848L10.6218 9.13254L10.615 9.12579L6.7853 5.29316C6.70432 5.21213 6.61249 5.14765 6.51425 5.10004L1.70711 0.292893ZM14.0524 15.4666L16.3882 17.8024C15.0649 18.5586 13.567 18.9735 12.0308 19C8.92197 18.9969 6.41113 17.2165 4.61498 15.2991C3.72526 14.3494 3.03996 13.3958 2.5772 12.6787C2.39727 12.3999 2.25197 12.1584 2.14231 11.9687C3.14442 10.2299 4.43707 8.67698 5.96306 7.37727L8.53875 9.95297C8.44984 10.099 8.37016 10.2509 8.30032 10.4077C8.08118 10.8999 7.96336 11.4312 7.95386 11.9699C7.94436 12.5086 8.04338 13.0438 8.24503 13.5434C8.44669 14.043 8.74685 14.4969 9.12765 14.878C9.50846 15.2591 9.96211 15.5596 10.4616 15.7615C10.961 15.9634 11.496 16.0625 12.0346 16.053C12.5732 16.0435 13.1044 15.9255 13.5964 15.7061C13.7537 15.636 13.906 15.5559 14.0524 15.4666ZM10.0404 11.4546L12.5515 13.9657C12.3728 14.0204 12.187 14.05 11.9993 14.0533C11.7295 14.0581 11.4614 14.0084 11.2111 13.9072C10.9608 13.8061 10.7334 13.6554 10.5424 13.4643C10.3514 13.2732 10.2009 13.0455 10.0997 12.7948C9.99848 12.5441 9.94878 12.2756 9.95355 12.0052C9.95685 11.8181 9.98618 11.6328 10.0404 11.4546ZM20.3693 15.6892C19.9407 15.3408 19.8757 14.711 20.224 14.2824C20.8071 13.565 21.3335 12.8009 21.7974 11.9968C21.6883 11.8084 21.544 11.5689 21.3655 11.2925C20.9045 10.5787 20.2218 9.6294 19.3354 8.68393C17.546 6.77523 15.0448 5.0031 11.9481 5C11.3172 5.01088 10.6929 5.08746 10.0845 5.22644C9.54613 5.34945 9.00994 5.0127 8.88694 4.47429C8.76393 3.93587 9.10068 3.39969 9.63909 3.27668C10.3848 3.10631 11.1502 3.01277 11.9236 3.00012L11.9399 2.99999C15.8394 2.99999 18.8355 5.22643 20.7945 7.31605C21.7831 8.37059 22.5379 9.4213 23.0456 10.2075C23.3001 10.6015 23.4941 10.9316 23.626 11.166C23.6919 11.2832 23.7424 11.3767 23.7772 11.4424C23.7946 11.4753 23.8081 11.5013 23.8176 11.5198L23.829 11.542L23.8324 11.5489L23.8336 11.5512L23.834 11.5521C23.8342 11.5524 23.8344 11.5528 22.9399 12L23.8344 11.5528C23.9797 11.8434 23.9747 12.1865 23.8211 12.4728C23.2366 13.5621 22.5513 14.59 21.776 15.5439C21.4277 15.9724 20.7979 16.0375 20.3693 15.6892Z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0H24V24H0V0Z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconEyeOpen = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.14074 12C2.25003 12.1889 2.39492 12.4296 2.57441 12.7075C3.03543 13.4213 3.71817 14.3706 4.60454 15.3161C6.39552 17.2264 8.89951 19 12 19C15.1005 19 17.6045 17.2264 19.3955 15.3161C20.2818 14.3706 20.9646 13.4213 21.4256 12.7075C21.6051 12.4296 21.75 12.1889 21.8593 12C21.75 11.8111 21.6051 11.5704 21.4256 11.2925C20.9646 10.5787 20.2818 9.6294 19.3955 8.68394C17.6045 6.77356 15.1005 5 12 5C8.89951 5 6.39552 6.77356 4.60454 8.68394C3.71817 9.6294 3.03543 10.5787 2.57441 11.2925C2.39492 11.5704 2.25003 11.8111 2.14074 12ZM23 12C23.8944 11.5528 23.8943 11.5524 23.8941 11.5521L23.8925 11.5489L23.889 11.542L23.8777 11.5198C23.8681 11.5013 23.8546 11.4753 23.8372 11.4424C23.8025 11.3767 23.752 11.2832 23.686 11.166C23.5542 10.9316 23.3601 10.6015 23.1057 10.2075C22.5979 9.42131 21.8432 8.3706 20.8545 7.31606C18.8955 5.22644 15.8995 3 12 3C8.10049 3 5.10448 5.22644 3.14546 7.31606C2.15683 8.3706 1.40207 9.42131 0.894336 10.2075C0.63985 10.6015 0.445792 10.9316 0.313971 11.166C0.248023 11.2832 0.19754 11.3767 0.162753 11.4424C0.145357 11.4753 0.131875 11.5013 0.122338 11.5198L0.11099 11.542L0.107539 11.5489L0.10637 11.5512C0.106186 11.5516 0.105573 11.5528 1 12L0.105573 11.5528C-0.0351909 11.8343 -0.0351909 12.1657 0.105573 12.4472L1 12C0.105573 12.4472 0.105389 12.4468 0.105573 12.4472L0.107539 12.4511L0.11099 12.458L0.122338 12.4802C0.131875 12.4987 0.145357 12.5247 0.162753 12.5576C0.19754 12.6233 0.248023 12.7168 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7925C1.40207 14.5787 2.15683 15.6294 3.14546 16.6839C5.10448 18.7736 8.10049 21 12 21C15.8995 21 18.8955 18.7736 20.8545 16.6839C21.8432 15.6294 22.5979 14.5787 23.1057 13.7925C23.3601 13.3985 23.5542 13.0684 23.686 12.834C23.752 12.7168 23.8025 12.6233 23.8372 12.5576C23.8546 12.5247 23.8681 12.4987 23.8777 12.4802L23.889 12.458L23.8925 12.4511L23.8936 12.4488C23.8938 12.4484 23.8944 12.4472 23 12ZM23 12L23.8944 12.4472C24.0352 12.1657 24.0348 11.8336 23.8941 11.5521L23 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z'
    />
  </svg>
);

export const IconFacebook = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path d='M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0z' />
  </svg>
);

export const IconFileMinus = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.879 1.879A3 3 0 016 1h8a1 1 0 01.707.293l6 6A1 1 0 0121 8v12a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 01.879-2.121zM6 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V8.414L13.586 3H6z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 1a1 1 0 011 1v5h5a1 1 0 110 2h-6a1 1 0 01-1-1V2a1 1 0 011-1zM8 15a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconFilePlus = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.879 1.879A3 3 0 016 1h8a1 1 0 01.707.293l6 6A1 1 0 0121 8v12a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 01.879-2.121zM6 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V8.414L13.586 3H6z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 1a1 1 0 011 1v5h5a1 1 0 110 2h-6a1 1 0 01-1-1V2a1 1 0 011-1zM12 11a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 15a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconFileText = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.879 1.879A3 3 0 016 1h8a1 1 0 01.707.293l6 6A1 1 0 0121 8v12a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 01.879-2.121zM6 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V8.414L13.586 3H6z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 1a1 1 0 011 1v5h5a1 1 0 110 2h-6a1 1 0 01-1-1V2a1 1 0 011-1zM7 13a1 1 0 011-1h8a1 1 0 110 2H8a1 1 0 01-1-1zM7 17a1 1 0 011-1h8a1 1 0 110 2H8a1 1 0 01-1-1zM7 9a1 1 0 011-1h2a1 1 0 110 2H8a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconFile = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.879 1.879A3 3 0 016 1h7a1 1 0 01.707.293l7 7A1 1 0 0121 9v11a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 01.879-2.121zM6 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V9.414L12.586 3H6z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 1a1 1 0 011 1v6h6a1 1 0 110 2h-7a1 1 0 01-1-1V2a1 1 0 011-1z'
    />
  </svg>
);

export const IconFire = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.687 2.37a1 1 0 01.12 1.071c-.738 1.502-.47 3.441.66 4.572.26.26.553.487.901.749l.091.068c.313.235.672.504 1.01.815l.028.028.084.084c.223.22.5.497.744.81.408.477.67.986.881 1.47l.118.236.03.062c1.118 2.687.348 5.79-1.746 7.72l-.001.001a7.04 7.04 0 01-2.247 1.384 1 1 0 01-1.36-.957.996.996 0 01.168-.538 3.46 3.46 0 00.582-1.883c0-.625-.194-1.091-.457-1.355a4.293 4.293 0 00-.528-.421l-.021-.015a6.08 6.08 0 01-.734-.597 5.362 5.362 0 00.17.779c.094.361.217.833.252 1.344.082 1.208-.328 2.466-1.77 3.846a1 1 0 01-.818.269c-2.29-.29-4.382-1.719-5.57-3.696a7.12 7.12 0 01-.827-1.971c-.198-.605-.263-1.189-.304-1.695v-.016c-.16-2.453.836-5.077 2.749-6.664a1 1 0 011.128-.102c.503-1.635 1.463-3.122 2.806-4.222l.003-.001c.76-.62 1.732-1.235 2.836-1.515a1 1 0 011.022.34zm-8.37 10.11a6.305 6.305 0 00-.18 1.918c.039.477.092.873.22 1.25.01.031.02.063.027.095a5.1 5.1 0 00.602 1.44l.001.002c.805 1.34 2.164 2.327 3.636 2.66.766-.85.844-1.452.813-1.912-.022-.32-.102-.63-.207-1.036l-.005-.018c-.097-.372-.224-.862-.224-1.379 0-.914.261-1.696.549-2.253a3.88 3.88 0 01.458-.703 2.05 2.05 0 01.27-.271c.052-.042.126-.097.218-.145.075-.04.258-.128.505-.128a1 1 0 011 1c0 .753.207 1.043.407 1.243.134.134.293.252.528.421l.021.015c.213.154.494.357.751.614.734.734 1.041 1.764 1.043 2.76 1.11-1.374 1.44-3.276.77-4.918l-.114-.228a.93.93 0 01-.023-.048c-.183-.421-.355-.735-.588-1.003a6.545 6.545 0 00-.626-.683l-.071-.071c-.255-.233-.53-.44-.85-.68l-.081-.061c-.347-.261-.744-.564-1.114-.934-1.21-1.21-1.754-2.918-1.645-4.577-.107.079-.212.16-.316.245-2.203 1.805-3.083 5.014-2.04 7.76 0 .004.002.006.003.01.042.104.145.358.145.685 0 .66-.425 1.197-.956 1.42-.64.28-1.278.074-1.686-.282a1.796 1.796 0 01-.301-.332 5.693 5.693 0 01-.94-1.877z'
    />
  </svg>
);

export const IconGear = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.293 2.293A1 1 0 0113 3v.094a2.65 2.65 0 001.601 2.423 2.65 2.65 0 002.918-.532l.069-.068a1 1 0 011.415 0 .999.999 0 010 1.416l-.06.06-.008.008a2.65 2.65 0 00-.607 2.729c.012.09.037.18.073.264A2.65 2.65 0 0020.826 11H21a1 1 0 010 2h-.094a2.65 2.65 0 00-2.423 1.601 2.65 2.65 0 00.532 2.918l.068.069a1 1 0 010 1.415 1 1 0 01-1.416 0l-.06-.06-.008-.008a2.651 2.651 0 00-2.918-.532 2.65 2.65 0 00-1.601 2.423V21a1 1 0 01-2 0V20.887a2.65 2.65 0 00-1.705-2.415 2.651 2.651 0 00-2.894.543l-.069.068a.999.999 0 01-1.415 0 1 1 0 010-1.416l.06-.06.008-.008a2.65 2.65 0 00.532-2.918 2.65 2.65 0 00-2.423-1.601H3a1 1 0 010-2H3.113a2.65 2.65 0 002.414-1.705 2.65 2.65 0 00-.542-2.894l-.068-.069a1 1 0 010-1.415 1 1 0 011.416 0l.06.06.008.008a2.65 2.65 0 002.729.607 1 1 0 00.264-.073A2.65 2.65 0 0011 3.174V3a1 1 0 01.293-.707zm9.022 13.11L19.4 15l.92.394a.65.65 0 01.593-.394H21a3 3 0 000-6h-.168a.65.65 0 01-.533-.285 1.006 1.006 0 00-.064-.199.65.65 0 01.127-.714l.055-.055a2.999 2.999 0 00-.973-4.895 3 3 0 00-3.271.651l-.055.055a.65.65 0 01-.714.127l-.01-.004A.65.65 0 0115 3.087V3a3 3 0 00-6 0v.167a.65.65 0 01-.285.534 1 1 0 00-.199.064.65.65 0 01-.714-.127l-.054-.055a3 3 0 10-4.245 4.244l.055.055a.65.65 0 01.127.714l-.024.059a.65.65 0 01-.585.425H3a3 3 0 100 6h.167a.65.65 0 01.594.394l.004.01a.65.65 0 01-.127.714l-.055.055a3 3 0 003.27 4.895c.365-.151.696-.372.974-.651l.055-.055a.65.65 0 01.714-.127l.059.023a.651.651 0 01.425.586V21a3 3 0 106 0v-.168a.65.65 0 01.394-.593l.01-.004a.65.65 0 01.714.127l.055.055a2.999 2.999 0 004.244 0l-.707-.707.707.707a2.999 2.999 0 000-4.245l-.055-.054a.65.65 0 01-.127-.714zM10 12a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z'
    />
  </svg>
);

export const IconGlassWine = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 0a1 1 0 00-.934.642 45.856 45.856 0 00-.319.861c-.19.524-.443 1.243-.697 2.02a37.895 37.895 0 00-.707 2.388C6.155 6.655 6 7.42 6 8c0 2.863 2.154 5.422 5.004 5.915A1.003 1.003 0 0011 14v8H9a1 1 0 100 2h6a1 1 0 100-2h-2v-8c0-.029-.001-.057-.004-.085C15.846 13.422 18 10.863 18 8c0-.58-.155-1.345-.343-2.09a37.912 37.912 0 00-.707-2.387 69.63 69.63 0 00-.992-2.818L15.94.659l-.006-.015V.642A1 1 0 0015 0H9zm.695 2l-.067.185a67.39 67.39 0 00-.678 1.96 35.94 35.94 0 00-.668 2.257c-.055.216-.102.415-.14.598h7.716a16.255 16.255 0 00-.14-.598 35.923 35.923 0 00-.668-2.257 67.151 67.151 0 00-.678-1.96L14.305 2h-4.61zm6.17 7h-7.73c.459 1.674 2.025 3 3.865 3 1.84 0 3.406-1.326 3.864-3z'
    />
  </svg>
);

export const IconGlobe = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.726 3.29A9.008 9.008 0 003.055 11H7.05a16.3 16.3 0 012.676-7.71zm4.548 0A16.3 16.3 0 0116.95 11h3.995a9.008 9.008 0 00-6.67-7.71zm.668 7.71A14.3 14.3 0 0012 3.55 14.3 14.3 0 009.058 11h5.884zm-5.884 2h5.884A14.3 14.3 0 0112 20.45 14.3 14.3 0 019.058 13zM7.05 13H3.055a9.008 9.008 0 006.67 7.71A16.3 16.3 0 017.05 13zm7.224 7.71A16.3 16.3 0 0016.95 13h3.995a9.008 9.008 0 01-6.67 7.71zM12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z'
    />
  </svg>
);

export const IconHash = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1104 2.00611C10.6593 2.0671 11.0549 2.56152 10.9939 3.11043L10.4506 8H14.4383L15.0061 2.88957C15.0671 2.34066 15.5615 1.94512 16.1104 2.00611C16.6593 2.0671 17.0549 2.56152 16.9939 3.11043L16.4506 8H20C20.5523 8 21 8.44771 21 9C21 9.55228 20.5523 10 20 10H16.2284L15.7839 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H15.5617L14.9939 21.1104C14.9329 21.6593 14.4385 22.0549 13.8896 21.9939C13.3407 21.9329 12.9451 21.4385 13.0061 20.8896L13.5494 16H9.56171L8.99388 21.1104C8.93289 21.6593 8.43848 22.0549 7.88957 21.9939C7.34066 21.9329 6.94513 21.4385 7.00612 20.8896L7.5494 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H7.77162L8.21607 10H4C3.44772 10 3 9.55228 3 9C3 8.44771 3.44772 8 4 8H8.43829L9.00612 2.88957C9.06711 2.34066 9.56152 1.94512 10.1104 2.00611ZM13.7716 14L14.2161 10H10.2284L9.78393 14H13.7716Z'
    />
  </svg>
);

export const IconHeadset = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 11V14C8 15.6569 6.65685 17 5 17C3.34315 17 2 15.6569 2 14V11C2 9.34315 3.34315 8 5 8C6.65685 8 8 9.34315 8 11ZM6 11V14C6 14.5523 5.55228 15 5 15C4.44772 15 4 14.5523 4 14V11C4 10.4477 4.44772 10 5 10C5.55228 10 6 10.4477 6 11ZM13 17H14C15.6569 17 17 18.3431 17 20C17 21.6569 15.6569 23 14 23H13C11.3431 23 10 21.6569 10 20C10 18.3431 11.3431 17 13 17ZM22 11V14C22 15.6569 20.6569 17 19 17C17.3431 17 16 15.6569 16 14V11C16 9.34315 17.3431 8 19 8C20.6569 8 22 9.34315 22 11ZM20 11V14C20 14.5523 19.5523 15 19 15C18.4477 15 18 14.5523 18 14V11C18 10.4477 18.4477 10 19 10C19.5523 10 20 10.4477 20 11ZM12 20C12 19.4477 12.4477 19 13 19H14C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21H13C12.4477 21 12 20.5523 12 20Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 13C4.0124 13.4181 4 13.5994 4 14C4 14.5523 3.60342 15 3.05114 15C2.49886 15 2.05114 14.5523 2.05114 14C2.05114 13.7163 2.04131 13.3626 2.03031 12.967C2.0101 12.2401 1.98596 11.3717 2.01166 10.5365C2.05314 9.1887 2.21962 7.67905 2.75484 6.26204C3.29659 4.82774 4.21882 3.48382 5.75132 2.51141C7.27284 1.54595 9.31169 1 12 1C14.6883 1 16.7271 1.54595 18.2487 2.51141C19.7812 3.48382 20.7034 4.82774 21.2451 6.26204C21.7804 7.67905 21.9469 9.18869 21.9883 10.5365C22.014 11.3717 21.9899 12.24 21.9697 12.9669C21.9624 13.2301 21.9556 13.4748 21.9519 13.6926C21.9831 13.7894 22 13.8927 22 14V17.9996L22 18.0012C21.9998 18.1021 21.9847 18.8566 21.4214 19.6045C20.8178 20.406 19.7401 21 18 21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19H18C19.2534 19 19.6757 18.598 19.8237 18.4014C19.9785 18.1959 19.998 17.9934 20 17.979V14.3165C19.9668 14.217 20 14.1106 20 14C20 13.5993 20 13.5 20 13C20.0198 12.3315 20.014 11.4018 19.9893 10.5981C19.9509 9.34977 19.7977 8.09018 19.3742 6.96873C18.9571 5.86457 18.2813 4.90079 17.1771 4.20013C16.0619 3.49251 14.4253 3 12 3C9.57465 3 7.93806 3.49251 6.82287 4.20013C5.71865 4.90079 5.04288 5.86457 4.62582 6.96873C4.20224 8.09018 4.04913 9.34977 4.01071 10.5981C3.98598 11.4018 3.98018 12.3314 4 13Z'
    />
  </svg>
);

export const IconHeart = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.462 2.493a6.5 6.5 0 018.99 6.007 6.499 6.499 0 01-1.905 4.597l-8.84 8.84a1 1 0 01-1.414 0l-8.84-8.84a6.501 6.501 0 019.192-9.196l.002.002.353.35.353-.35.002-.002a6.5 6.5 0 012.107-1.408zm2.488 1.505a4.5 4.5 0 00-3.183 1.319l-.003.003-1.06 1.05a1 1 0 01-1.408 0l-1.063-1.053a4.501 4.501 0 00-6.366 6.366L12 19.816l8.133-8.133a4.501 4.501 0 00-3.183-7.685z'
    />
  </svg>
);

export const IconHelpCircle = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11.258-3.976a2 2 0 00-2.225 1.308 1 1 0 11-1.886-.664 4 4 0 017.773 1.333c0 1.53-1.135 2.54-1.945 3.081a8.036 8.036 0 01-1.686.848l-.035.013-.011.003-.004.002h-.002L11.92 13l.316.949a1 1 0 01-.633-1.897H11.6h.003l.015-.006.074-.027a6.046 6.046 0 001.172-.6c.69-.46 1.055-.95 1.055-1.419v-.001a2 2 0 00-1.662-1.975zM12 16a1 1 0 100 2h.01a1 1 0 100-2H12z'
    />
  </svg>
);

export const IconHourglass = (
  <svg viewBox='0 0 20 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H14V7C14 7.35126 13.8157 7.67677 13.5145 7.85749L9.94365 10L13.5145 12.1425C13.8157 12.3232 14 12.6487 14 13V18H15C15.5523 18 16 18.4477 16 19C16 19.5523 15.5523 20 15 20H1C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18H2V13C2 12.6487 2.1843 12.3232 2.4855 12.1425L6.05635 10L2.4855 7.85749C2.1843 7.67677 2 7.35126 2 7V2H1C0.447715 2 0 1.55228 0 1ZM8 8.83381L12 6.43381V2H4V6.43381L8 8.83381ZM8 11.1662L4 13.5662V18H12V13.5662L8 11.1662ZM6 15C6 14.4477 6.44772 14 7 14H9C9.55229 14 10 14.4477 10 15C10 15.5523 9.55229 16 9 16H7C6.44772 16 6 15.5523 6 15Z'
    />
  </svg>
);

export const IconInfo = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-1a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1zm0-4a1 1 0 100 2h.01a1 1 0 100-2H12z'
    />
  </svg>
);

export const IconLoader = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      opacity='.25'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 109 9 1 1 0 112 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1a1 1 0 110 2z'
    />
  </svg>
);

export const IconLock = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.172 4.172A4 4 0 0116 7v3H8V7a4 4 0 011.172-2.828zM6 10V7a6 6 0 1112 0v3h1a3 3 0 013 3v7a3 3 0 01-3 3H5a3 3 0 01-3-3v-7a3 3 0 013-3h1zm11 2h2a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1v-7a1 1 0 011-1h12zm-6 4a1 1 0 011-1h.01a1 1 0 110 2H12a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconLogin = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M14.614 2.056a.823.823 0 0 0-.505.397c-.074.139-.089.231-.089.547 0 .331.013.403.1.558.11.197.294.34.515.401.089.025.982.041 2.308.041 2.475 0 2.448-.003 2.754.303.327.328.303-.294.303 7.698 0 5.906-.009 7.137-.055 7.289a1.02 1.02 0 0 1-.461.582l-.184.108-2.321.02-2.321.02-.199.102c-.34.175-.481.484-.45.982.03.464.244.752.639.858.103.028.963.038 2.544.029 2.376-.013 2.389-.013 2.668-.106a3.111 3.111 0 0 0 2.026-2.045l.094-.3V4.46l-.094-.3a3.084 3.084 0 0 0-2.025-2.038l-.321-.1-2.38-.009c-1.888-.008-2.414.001-2.546.043M9.626 6.045c-.206.109-.48.388-.588.599a.792.792 0 0 0 .002.719c.06.12.639.729 1.813 1.907L12.578 11H7.695c-5.233 0-5.087-.005-5.373.199-.222.158-.302.369-.302.801 0 .331.013.403.1.558.11.197.294.34.515.401.094.026 1.885.041 5.044.041h4.899l-1.725 1.73C9.679 15.908 9.1 16.517 9.04 16.637c-.177.352-.088.717.259 1.064.347.347.711.436 1.064.259.123-.061.95-.857 2.698-2.594 1.387-1.378 2.573-2.54 2.635-2.582.154-.102.353-.545.353-.784 0-.256-.198-.679-.373-.799-.075-.051-1.261-1.213-2.636-2.583-1.661-1.654-2.557-2.518-2.668-2.574a.884.884 0 0 0-.746.001'
      fillRule='evenodd'
    />
  </svg>
);

export const IconLogout = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M4.499 2.043a3.044 3.044 0 0 0-2.387 2.135L2.02 4.5v15l.092.322a3.08 3.08 0 0 0 2.066 2.066c.32.092.335.092 2.765.092h2.443l.195-.12c.241-.149.377-.394.408-.734.043-.472-.128-.849-.456-1.011l-.193-.095L7.02 20l-2.32-.02-.189-.111a1.038 1.038 0 0 1-.454-.539c-.079-.223-.079-14.437 0-14.66.079-.221.241-.414.454-.539L4.7 4.02 7.043 4l2.343-.02.195-.12c.247-.153.38-.397.408-.751.028-.344-.066-.664-.25-.847-.26-.26-.289-.263-2.796-.257-1.234.002-2.334.02-2.444.038m11.127 4.002a1.68 1.68 0 0 0-.583.59.864.864 0 0 0 .001.737c.055.109.69.775 1.809 1.897l1.724 1.73-4.96.01-4.959.011-.199.102a.76.76 0 0 0-.319.297c-.112.181-.12.222-.12.578 0 .347.011.401.111.572a.862.862 0 0 0 .3.3l.189.111 4.978.011 4.978.011-1.723 1.729c-1.119 1.122-1.754 1.788-1.809 1.897-.176.352-.085.733.255 1.073.34.34.721.431 1.073.255.111-.056 1.007-.92 2.668-2.574 1.375-1.37 2.558-2.53 2.629-2.578.182-.124.371-.533.371-.804s-.189-.68-.371-.804c-.071-.048-1.254-1.208-2.629-2.578-1.661-1.654-2.557-2.518-2.668-2.574a.884.884 0 0 0-.746.001'
      fillRule='evenodd'
    />
  </svg>
);

export const IconLolipop = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 2a5 5 0 100 10 5 5 0 000-10zm-7 5a7 7 0 1114 0 7 7 0 01-14 0z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.207 10.793a1 1 0 010 1.414l-10.5 10.5a1 1 0 01-1.414-1.414l10.5-10.5a1 1 0 011.414 0zM11.293 1.293a1 1 0 011.414 0l10 10a1 1 0 01-1.414 1.414l-10-10a1 1 0 010-1.414z'
    />
  </svg>
);

export const IconMail = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.107 5.554C3.272 5.227 3.612 5 4 5h16c.388 0 .728.227.893.554L12 11.779 3.107 5.554zM3 7.921V18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V7.92l-8.427 5.9a1 1 0 01-1.146 0L3 7.92zM4 3C2.348 3 1 4.348 1 6v12c0 1.652 1.348 3 3 3h16c1.652 0 3-1.348 3-3V6c0-1.652-1.348-3-3-3H4z'
    />
  </svg>
);

export const IconMapPinOff = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.707.293A1 1 0 00.293 1.707L3.43 4.845A10 10 0 002 10c0 3.902 2.484 7.396 4.774 9.813a31.428 31.428 0 004.254 3.726 18.887 18.887 0 00.384.27l.023.016.007.005.003.002c.336.224.774.223 1.11 0l.004-.003.009-.006.031-.02.113-.079c.097-.067.236-.166.41-.293.347-.255.834-.627 1.404-1.1a30.35 30.35 0 003.261-3.13l4.506 4.506a1 1 0 001.414-1.414l-22-22zm14.664 17.492l-3.902-3.902A.996.996 0 0112 14a4 4 0 01-4-4c0-.17.042-.33.117-.47L4.9 6.315A8 8 0 004 10c0 3.098 2.016 6.104 4.226 8.437A29.419 29.419 0 0012 21.773c.316-.234.748-.565 1.25-.98a28.242 28.242 0 003.12-3.008zM12 2a8 8 0 00-4 1.072A1 1 0 017 1.34 10 10 0 0122 10c0 1.762-.508 3.434-1.258 4.945a1 1 0 01-1.791-.89C19.603 12.742 20 11.375 20 10a8 8 0 00-8-8zm-1 5a1 1 0 011-1 4 4 0 014 4 1 1 0 11-2 0 2 2 0 00-2-2 1 1 0 01-1-1z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconMapPin = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.343 4.343A8 8 0 0120 10c0 3.098-2.016 6.104-4.226 8.437A29.412 29.412 0 0112 21.773a29.419 29.419 0 01-3.774-3.335C6.016 16.103 4 13.097 4 10a8 8 0 012.343-5.657zm5.102 19.489L12 23l.555.832a1 1 0 01-1.11 0zm0 0L12 23c.555.832.556.831.556.831l.002-.001.007-.005.023-.015.082-.057c.072-.05.174-.12.302-.214a31.433 31.433 0 004.254-3.727C19.516 17.397 22 13.903 22 10a10 10 0 00-20 0c0 3.902 2.484 7.396 4.774 9.813a31.428 31.428 0 004.254 3.726 18.887 18.887 0 00.384.27l.023.016.007.005.003.002zM10 10a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z'
    />
  </svg>
);

export const IconMenu = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zm0 6a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zm1 5a1 1 0 100 2h18a1 1 0 100-2H3z'
    />
  </svg>
);

export const IconMinus = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 12a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconMoon = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.081 2.509a1 1 0 01-.067 1.085 6 6 0 008.392 8.392 1 1 0 011.59.896A10 10 0 1111.118 2.004a1 1 0 01.963.505zm-2.765 1.93a8 8 0 1010.245 10.245A7.999 7.999 0 019.316 4.439z'
    />
  </svg>
);

export const IconNavigation = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.707 1.293a1 1 0 01.197 1.135l-9 19a1 1 0 01-1.874-.186l-1.855-7.417-7.418-1.855a1 1 0 01-.185-1.874l19-9a1 1 0 011.135.197zM5.953 10.708l5.29 1.322a1 1 0 01.727.728l1.322 5.289 6.606-13.945-13.945 6.606z'
    />
  </svg>
);

export const IconNumber = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 6a1 1 0 00-1.707-.707l-2 2a1 1 0 001.414 1.414L3 8.414V18a1 1 0 102 0V6zm4 3a2 2 0 114 0c0 .58-.247 1.187-.746 1.873-.503.69-1.189 1.367-1.946 2.093l-.182.174c-.679.649-1.408 1.346-1.973 2.06C7.541 15.974 7 16.914 7 18a1 1 0 001 1h6a1 1 0 100-2H9.33a5.18 5.18 0 01.392-.56c.474-.598 1.103-1.2 1.81-1.877l.16-.154c.743-.711 1.557-1.504 2.18-2.36C14.496 11.19 15 10.171 15 9a4 4 0 00-8 0 1 1 0 002 0zm9 0a2 2 0 112 2 1 1 0 100 2 2 2 0 11-2 2 1 1 0 10-2 0 4 4 0 106.646-3A4 4 0 1016 9a1 1 0 102 0z'
    />
  </svg>
);

export const IconOption = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 5a2 2 0 114 0 2 2 0 01-4 0zm0 7a2 2 0 114 0 2 2 0 01-4 0zm2 5a2 2 0 100 4 2 2 0 000-4z'
    />
  </svg>
);

export const IconPackage = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.555 2.34553L11.5559 2.34508C11.6939 2.27666 11.8459 2.24106 12 2.24106C12.1541 2.24106 12.306 2.27666 12.4441 2.34508L12.445 2.34553L19.7589 6.00251L17 7.38197L9.24106 3.50249L11.555 2.34553ZM6.469 2.65246L2.66499 4.55447L2.66375 4.55508C2.16448 4.80346 1.7443 5.18609 1.45041 5.66003C1.15627 6.13436 1.00028 6.68134 0.999988 7.23947L0.999987 7.24V16.7569C0.996817 17.3146 1.14921 17.8623 1.44009 18.3383C1.73164 18.8153 2.15071 19.2015 2.65001 19.453L2.65277 19.4544L10.6525 23.4543C11.0693 23.6628 11.5289 23.7714 11.995 23.7714C12.4609 23.7714 12.9205 23.6629 13.3372 23.4544L13.3375 23.4543L21.335 19.4555L21.336 19.455C21.8354 19.2067 22.2556 18.824 22.5496 18.35C22.8437 17.8756 22.9997 17.3287 23 16.7705V16.77V7.24V7.23947C22.9997 6.68134 22.8437 6.13436 22.5496 5.66003C22.2557 5.18611 21.8355 4.80349 21.3363 4.5551L21.335 4.55447L13.3372 0.55557L12.89 1.45L13.335 0.554467C12.9202 0.34833 12.4632 0.241058 12 0.241058C11.5368 0.241058 11.0798 0.34833 10.665 0.554467L10.6628 0.55557L6.63928 2.56732C6.58011 2.59018 6.52306 2.61866 6.469 2.65246ZM7.00499 4.62053L14.7639 8.5L12 9.88197L4.24106 6.0025L7.00499 4.62053ZM17.4388 9.39866L13 11.618V21.387L20.4428 17.6656L20.445 17.6645C20.6116 17.5817 20.7518 17.4541 20.8498 17.2959C20.9479 17.1378 20.9999 16.9555 21 16.7695V7.61805L17.4571 9.38952C17.451 9.39263 17.4449 9.39568 17.4388 9.39866ZM2.99999 7.61803L2.99999 16.76V16.767H2.99996C2.99867 16.9533 3.04947 17.1363 3.14666 17.2954C3.24368 17.4541 3.38307 17.5827 3.54914 17.6665L3.54996 17.667L11 21.392V11.618L2.99999 7.61803Z'
    />
  </svg>
);

export const IconPen = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.703 3.71l-.289.29L20 7.586l.288-.289h.001l.008-.009.05-.055a3.347 3.347 0 00.642-1.111c.114-.344.16-.711.085-1.09-.074-.371-.28-.824-.781-1.325s-.954-.707-1.325-.781a2.105 2.105 0 00-1.09.085 3.348 3.348 0 00-1.166.692l-.009.008zM18.586 9L15 5.414l-11 11V20h3.586l11-11zM19.36.965c.8.16 1.598.58 2.347 1.328.749.749 1.168 1.546 1.328 2.347.159.793.05 1.52-.149 2.114a5.344 5.344 0 01-1.16 1.934l-.011.012-.005.004-.001.002h-.001L21 8l.707.707-13 13A1 1 0 018 22H3a1 1 0 01-1-1v-5a1 1 0 01.293-.707l13-13L16 3a94.175 94.175 0 01-.706-.708l.002-.002.004-.005.012-.01a2.663 2.663 0 01.145-.133 5.343 5.343 0 011.789-1.028 4.102 4.102 0 012.114-.15z'
    />
  </svg>
);

export const IconPhoneChecked = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.7221 2.69174C23.1042 2.29291 23.0906 1.65989 22.6917 1.27786C22.2929 0.895817 21.6599 0.909431 21.2779 1.30826L17.2105 5.55437L15.7221 4.00057C15.3401 3.60174 14.7071 3.58813 14.3083 3.97016C13.9094 4.3522 13.8958 4.98522 14.2779 5.38405L16.4884 7.69174C16.677 7.88865 16.9379 8 17.2105 8C17.4832 8 17.7441 7.88865 17.9327 7.69174L22.7221 2.69174ZM22.0262 22.1388C22.6487 21.5678 23.0015 20.7608 22.9981 19.916L22.9981 16.9313C23.029 15.4143 21.9216 14.1121 20.4178 13.8999C19.5236 13.7819 18.6543 13.5654 17.8177 13.2532C16.7237 12.8419 15.4878 13.1055 14.655 13.929L13.9339 14.6501C12.0893 13.4742 10.524 11.9089 9.34813 10.0643L10.0652 9.34721C10.8927 8.51045 11.1563 7.27455 10.7442 6.17824C10.4328 5.34388 10.2163 4.47464 10.0995 3.58934C9.88752 2.0891 8.60407 0.985329 7.09827 1.00015L4.10811 1.0001C3.26506 1.00089 2.46206 1.35559 1.89432 1.97753C1.32658 2.59948 1.04638 3.43141 1.12217 4.2701C1.46853 7.53288 2.57341 10.6532 4.34883 13.3938C5.95817 15.9265 8.11171 18.08 10.6518 19.6941C13.3722 21.4584 16.4774 22.563 19.7101 22.9142C20.5694 22.9921 21.4038 22.7099 22.0262 22.1388ZM20.9984 16.8953L20.9981 16.9201V19.9201C20.9993 20.2057 20.8816 20.4747 20.6742 20.6651C20.4667 20.8554 20.1886 20.9495 19.9081 20.9242C17.0045 20.6085 14.198 19.6101 11.7322 18.0111C9.43217 16.5495 7.48873 14.606 6.03213 12.3138C4.42277 9.82943 3.42418 7.00931 3.11252 4.0745C3.08879 3.81054 3.18219 3.53323 3.37144 3.32591C3.56068 3.11859 3.82835 3.00036 4.10905 3.0001L7.10811 3.0001C7.61989 2.99511 8.0477 3.36304 8.11795 3.86005C8.25318 4.8857 8.5063 5.90177 8.87122 6.87971C9.00943 7.2474 8.92157 7.65936 8.64706 7.93696L7.38101 9.20299C7.06269 9.52131 6.99631 10.0131 7.21882 10.4044C8.73135 13.0644 10.9338 15.2669 13.5938 16.7794C13.9851 17.0019 14.4769 16.9355 14.7952 16.6172L16.0652 15.3472C16.3388 15.0766 16.7508 14.9888 17.1163 15.1262C18.0964 15.4919 19.1125 15.745 20.1474 15.8815C20.6412 15.9512 21.011 16.3877 20.9984 16.8953Z'
    />
  </svg>
);

export const IconPhoneMissed = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.026 22.139a3 3 0 00.972-2.223v-2.985a3 3 0 00-2.58-3.031 11.863 11.863 0 01-2.6-.647 2.999 2.999 0 00-3.163.676l-.721.721a15.002 15.002 0 01-4.586-4.586l.717-.717a3.002 3.002 0 00.68-3.169A11.834 11.834 0 0110.1 3.59 3.002 3.002 0 007.098 1h-2.99a3 3 0 00-2.986 3.27 20.804 20.804 0 003.227 9.124 20.49 20.49 0 006.303 6.3 20.778 20.778 0 009.058 3.22 3.009 3.009 0 002.316-.775zm-1.028-5.244v3.025a1.002 1.002 0 01-1.09 1.004 18.775 18.775 0 01-8.176-2.913 18.512 18.512 0 01-5.7-5.697 18.8 18.8 0 01-2.92-8.24A1 1 0 014.11 3h3c.51-.005.939.363 1.009.86.135 1.026.388 2.042.753 3.02a1 1 0 01-.224 1.057L7.381 9.203a1 1 0 00-.162 1.201 17 17 0 006.375 6.375 1 1 0 001.201-.162l1.27-1.27a.998.998 0 011.051-.22c.98.365 1.997.618 3.031.755.494.07.864.506.851 1.013zm.82-14.602a1 1 0 010 1.414L19.523 6l2.293 2.293a1 1 0 01-1.414 1.414L18.11 7.414l-2.293 2.293a1 1 0 01-1.414-1.414L16.696 6l-2.293-2.293a1 1 0 011.414-1.414l2.293 2.293 2.293-2.293a1 1 0 011.414 0z'
    />
  </svg>
);

export const IconPhoneOff = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.063 12.523L22.293.293a1 1 0 111.414 1.414L12.123 13.291c.569.498 1.175.952 1.813 1.359l.72-.721a3 3 0 013.164-.676c.836.312 1.705.529 2.6.647A2.998 2.998 0 0123 16.89v2.996a3 3 0 01-3.288 2.998 20.78 20.78 0 01-9.058-3.22 20.418 20.418 0 01-2.782-2.122l-6.165 6.165a1 1 0 01-1.414-1.414l9.6-9.6a1.003 1.003 0 01.17-.17zm.643 2.185l-1.418 1.418c.76.683 1.577 1.303 2.446 1.855a18.775 18.775 0 008.176 2.913A1 1 0 0021 19.89v-3.01a.998.998 0 00-.85-.999 13.849 13.849 0 01-3.032-.755.998.998 0 00-1.05.221l-1.27 1.27a1 1 0 01-1.202.162 16.995 16.995 0 01-2.89-2.07zM5.734 13.65a1 1 0 00.295-1.383 18.79 18.79 0 01-2.915-8.194A1 1 0 014.111 3H7.11c.512-.005.94.363 1.01.86.135 1.026.388 2.042.753 3.02a1 1 0 01-.224 1.057L7.383 9.203a1 1 0 101.414 1.414l1.27-1.27a3.002 3.002 0 00.679-3.169 11.834 11.834 0 01-.645-2.589 3.002 3.002 0 00-3-2.589H4.11a3 3 0 00-2.986 3.27 20.806 20.806 0 003.227 9.084 1 1 0 001.383.295z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconPhone = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path d='M22.998 19.916a3 3 0 01-3.288 2.998 20.778 20.778 0 01-9.058-3.22 20.49 20.49 0 01-6.303-6.3A20.804 20.804 0 011.122 4.27 3 3 0 014.108 1h2.99A3.002 3.002 0 0110.1 3.59c.116.885.333 1.754.644 2.588a3.002 3.002 0 01-.679 3.17l-.717.716a15.002 15.002 0 004.586 4.586l.721-.721a2.999 2.999 0 013.163-.676c.836.312 1.706.529 2.6.647a3 3 0 012.58 3.031v2.985zm-2-2.996v-.025a.998.998 0 00-.85-1.013 13.847 13.847 0 01-3.032-.756.998.998 0 00-1.05.221l-1.27 1.27a1 1 0 01-1.202.162 17 17 0 01-6.375-6.375 1 1 0 01.162-1.201l1.266-1.266a1 1 0 00.224-1.057 13.817 13.817 0 01-.753-3.02A1.003 1.003 0 007.108 3H4.11a1 1 0 00-.996 1.074 18.8 18.8 0 002.92 8.24 18.512 18.512 0 005.7 5.697 18.775 18.775 0 008.175 2.913 1 1 0 001.09-1.004v-3z' />
  </svg>
);

export const IconPlaneArrival = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 25'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.568 1.088C9.614.529 7.759 2.233 8.15 4.228l.6 3.056-3.13-.82-.081-.265a3.75 3.75 0 00-2.193-2.385A1.71 1.71 0 001 5.402v4.625c0 1.066.72 1.998 1.751 2.269l16.506 4.323c.876.23 1.808.075 2.563-.425 2.282-1.51 1.722-5.005-.919-5.725l-.183-.05-.01-.003-4.57-1.197-3.401-7.142a1.86 1.86 0 00-1.17-.99zm-1.455 2.755a.721.721 0 01.846-.846l3.573 7.502.2.42.45.117 5.014 1.314.18.048c.98.268 1.189 1.567.34 2.128-.28.186-.626.243-.952.158L3.258 10.361A.345.345 0 013 10.027V5.894c.295.22.516.53.626.89l.245.8.163.532.54.142 5.21 1.364 1.54.404-.306-1.563-.905-4.62zM23 19H1a1 1 0 100 2h22a1 1 0 100-2zm0 3.625H1a1 1 0 100 2h22a1 1 0 100-2z'
    />
  </svg>
);

export const IconPlus = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 3a1 1 0 10-2 0v8H3a1 1 0 100 2h8v8a1 1 0 102 0v-8h8a1 1 0 100-2h-8V3z'
    />
  </svg>
);

export const IconPower = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 2a1 1 0 10-2 0v10a1 1 0 102 0V2zM6.337 7.347a1 1 0 10-1.414-1.414 10 10 0 1014.144 0 1 1 0 10-1.414 1.414 8 8 0 11-11.316 0z'
    />
  </svg>
);

export const IconRefresh = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.141 4.996a8 8 0 019.543 1.372L20.528 9H17a1 1 0 100 2h6a1 1 0 001-1V4a1 1 0 10-2 0v3.637l-2.934-2.715a10 10 0 102.367 10.411 1 1 0 10-1.886-.666 8 8 0 11-11.406-9.67z'
    />
  </svg>
);

export const IconRepeat = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.7071 0.292893C17.3166 -0.0976311 16.6834 -0.0976311 16.2929 0.292893C15.9024 0.683417 15.9024 1.31658 16.2929 1.70711L18.5858 4H7C5.67392 4 4.40215 4.52678 3.46447 5.46447C2.52678 6.40215 2 7.67392 2 9V11C2 11.5523 2.44772 12 3 12C3.55228 12 4 11.5523 4 11V9C4 8.20435 4.31607 7.44129 4.87868 6.87868C5.44129 6.31607 6.20435 6 7 6H18.5858L16.2929 8.29289C15.9024 8.68342 15.9024 9.31658 16.2929 9.70711C16.6834 10.0976 17.3166 10.0976 17.7071 9.70711L21.7071 5.70711C21.8902 5.52405 21.9874 5.28768 21.9989 5.04797C21.9996 5.03199 22 5.016 22 5L17.7071 0.292893ZM17.7071 0.292893L21.7071 4.29289C21.9 4.48581 21.9976 4.73793 22 4.99077L17.7071 0.292893ZM22 15V13C22 12.4477 21.5523 12 21 12C20.4477 12 20 12.4477 20 13V15C20 15.7956 19.6839 16.5587 19.1213 17.1213C18.5587 17.6839 17.7956 18 17 18H5.41421L7.70711 15.7071C8.09763 15.3166 8.09763 14.6834 7.70711 14.2929C7.31658 13.9024 6.68342 13.9024 6.29289 14.2929L2.29289 18.2929C2.19702 18.3888 2.12468 18.4993 2.07588 18.6172C2.02699 18.7351 2 18.8644 2 19C2 19.1356 2.02699 19.2649 2.07588 19.3828C2.12468 19.5007 2.19702 19.6112 2.29289 19.7071L6.29289 23.7071C6.68342 24.0976 7.31658 24.0976 7.70711 23.7071C8.09763 23.3166 8.09763 22.6834 7.70711 22.2929L5.41421 20H17C18.3261 20 19.5979 19.4732 20.5355 18.5355C21.4732 17.5979 22 16.3261 22 15Z'
    />
  </svg>
);

export const IconRoadSign = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 3h18a1 1 0 011 1v8a1 1 0 01-1 1h-3v7a1 1 0 11-2 0v-7H6v7a1 1 0 11-2 0v-7H1a1 1 0 01-1-1V4a1 1 0 011-1h4zM2.586 5H2v.586L2.586 5zM2 8.414V11h2.134c.042-.074.096-.144.159-.207L10.086 5H5.414L2 8.414zM12.914 5l-6 6h4.672l6-6h-4.672zm7.5 0l-6 6h4.172L22 7.586V5h-1.586zM22 10.414l-.586.586H22v-.586z'
    />
  </svg>
);

export const IconSadFace = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 15c-2.005 0-2.934 1.104-3.106 1.447a1 1 0 11-1.788-.894C7.6 14.563 9.205 13 12 13s4.4 1.563 4.894 2.553a1 1 0 11-1.788.894C14.934 16.104 14.005 15 12 15zM8 9a1 1 0 011-1h.01a1 1 0 010 2H9a1 1 0 01-1-1zM14 9a1 1 0 011-1h.01a1 1 0 110 2H15a1 1 0 01-1-1z'
    />
  </svg>
);

export const IconSearch = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 11a7 7 0 1112.041 4.856.998.998 0 00-.185.185A7 7 0 014 11zm12.618 7.032a9 9 0 111.414-1.414l3.675 3.675a1 1 0 01-1.414 1.414l-3.675-3.675z'
    />
  </svg>
);

export const IconSearchPlus = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path d='M11 7C11.5523 7 12 7.44772 12 8V10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H12V14C12 14.5523 11.5523 15 11 15C10.4477 15 10 14.5523 10 14V12H8C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10H10V8C10 7.44772 10.4477 7 11 7Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.6177 18.0319C15.078 19.2635 13.125 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 13.125 19.2635 15.078 18.0319 16.6177L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.6177 18.0319ZM4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.8859 17.2542 14.5977 16.0414 15.8564C16.0072 15.8827 15.9743 15.9115 15.9429 15.9429C15.9115 15.9742 15.8827 16.0072 15.8564 16.0414C14.5977 17.2542 12.8859 18 11 18C7.13401 18 4 14.866 4 11Z'
    />
  </svg>
);

export const IconSeatbelt = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.707 1.707A1 1 0 0020.293.293L16.98 3.606l-1.262-1.302a1 1 0 00-1.425-.011l-2 2A1 1 0 0012 5v2.586L9.793 9.793a1 1 0 000 1.414l3 3a1 1 0 001.414 0L16.414 12H19a1 1 0 00.707-.293l2-2a1 1 0 000-1.414L20.414 7l3.293-3.293a1 1 0 00-1.414-1.414l-3.304 3.304-.595-.577 3.313-3.313zM16.273 5.75l2.025 1.964L19.586 9l-1 1H16a1 1 0 00-.707.293L13.5 12.086 11.914 10.5l1.793-1.793A1 1 0 0014 8V5.414l.989-.989 1.262 1.302a.869.869 0 00.022.022zm-8.566 5.544a1 1 0 00-1.496.093l-3.5 4.5a1 1 0 00.082 1.321l.293.293-2.793 2.793a1 1 0 101.414 1.414L4.5 18.914l.586.586-2.793 2.793a1 1 0 101.414 1.414L6.5 20.914l.293.293a1 1 0 001.32.082l4.5-3.5a1 1 0 00.094-1.496l-5-5zm-2.876 5.124l2.263-2.909 3.398 3.398-2.91 2.263-2.75-2.752zm16.876-.71a1 1 0 00-1.414-1.414L16 18.586V17a1 1 0 10-2 0v4a1 1 0 001 1h4a1 1 0 100-2h-1.586l4.293-4.293z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconShield = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.649 1.064a1 1 0 01.702 0l8 3A1 1 0 0121 5v7c0 3.446-2.282 6.2-4.341 8.003a22.684 22.684 0 01-4.104 2.836 8.28 8.28 0 01-.076.04l-.022.01-.006.004h-.002s-.002.001-.449-.893l-.448.894-.003-.001-.006-.004-.022-.01a8.28 8.28 0 01-.35-.188 22.686 22.686 0 01-3.83-2.689C5.281 18.2 3 15.447 3 12V5a1 1 0 01.649-.936l8-3zM12 22l-.448.894c.282.14.614.141.895 0L12 22zm0-1.137a20.69 20.69 0 003.341-2.365C17.282 16.8 19 14.553 19 12V5.693l-7-2.625-7 2.625V12c0 2.554 1.718 4.8 3.659 6.497A20.692 20.692 0 0012 20.863z'
    />
  </svg>
);

export const IconShoppingBag = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.2 1.4A1 1 0 016 1h12a1 1 0 01.8.4l3 4a1 1 0 01.2.6v14a3 3 0 01-3 3H5a3 3 0 01-3-3V6a1 1 0 01.2-.6l3-4zM6.5 3L5 5h14l-1.5-2h-11zM4 20V7h16v13a1 1 0 01-1 1H5a1 1 0 01-1-1zm5-10a1 1 0 10-2 0 5 5 0 1010 0 1 1 0 10-2 0 3 3 0 01-6 0z'
    />
  </svg>
);

export const IconSliders = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 2C4.55228 2 5 2.44772 5 3V10C5 10.5523 4.55228 11 4 11C3.44772 11 3 10.5523 3 10V3C3 2.44772 3.44772 2 4 2ZM5 15H7C7.55228 15 8 14.5523 8 14C8 13.4477 7.55228 13 7 13H4H1C0.447715 13 0 13.4477 0 14C0 14.5523 0.447715 15 1 15H3V21C3 21.5523 3.44772 22 4 22C4.55228 22 5 21.5523 5 21V15ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V12ZM12 2C12.5523 2 13 2.44772 13 3V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H12H9C8.44771 9 8 8.55228 8 8C8 7.44772 8.44771 7 9 7H11V3C11 2.44772 11.4477 2 12 2ZM20 15H23C23.5523 15 24 15.4477 24 16C24 16.5523 23.5523 17 23 17H21V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V17H17C16.4477 17 16 16.5523 16 16C16 15.4477 16.4477 15 17 15H20ZM20 2C20.5523 2 21 2.44772 21 3V12C21 12.5523 20.5523 13 20 13C19.4477 13 19 12.5523 19 12V3C19 2.44772 19.4477 2 20 2Z'
    />
  </svg>
);

export const IconSmartphone = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 4a1 1 0 011-1h10a1 1 0 011 1v16a1 1 0 01-1 1H7a1 1 0 01-1-1V4zm1-3a3 3 0 00-3 3v16a3 3 0 003 3h10a3 3 0 003-3V4a3 3 0 00-3-3H7zm5 16a1 1 0 100 2h.01a1 1 0 100-2H12z'
    />
  </svg>
);

export const IconStarSolid = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.897 1.557a1 1 0 00-1.794 0l-2.857 5.79-6.39.934a1 1 0 00-.554 1.705l4.623 4.503-1.09 6.362a1 1 0 001.45 1.054L12 18.9l5.715 3.005a1 1 0 001.45-1.054l-1.09-6.362 4.623-4.503a1 1 0 00-.553-1.705l-6.39-.935-2.858-5.789z'
    />
  </svg>
);

export const IconStar = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 1a1 1 0 01.897.557l2.857 5.79 6.39.934a1 1 0 01.554 1.705l-4.623 4.503 1.09 6.362a1 1 0 01-1.45 1.054L12 18.9l-5.715 3.005a1 1 0 01-1.45-1.054l1.09-6.362-4.623-4.503a1 1 0 01.553-1.705l6.39-.935 2.858-5.789A1 1 0 0112 1zm0 3.26L9.807 8.702a1 1 0 01-.752.546l-4.907.718 3.55 3.457a1 1 0 01.288.885l-.838 4.883 4.386-2.307a1 1 0 01.931 0l4.387 2.307-.838-4.883a1 1 0 01.288-.885l3.55-3.457-4.907-.718a1 1 0 01-.752-.546L12 4.259z'
    />
  </svg>
);

export const IconSteeringWheel = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a9 9 0 00-8.972 9.712l6.082-1.52a3.001 3.001 0 015.78 0l6.082 1.52A9 9 0 0012 3zm-1 17.945a9.009 9.009 0 01-7.594-6.266l5.85-1.463A3.01 3.01 0 0011 14.83v6.116zm2 0a9.009 9.009 0 007.594-6.266l-5.85-1.463A3.01 3.01 0 0113 14.83v6.116zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-1a1 1 0 100 2 1 1 0 000-2z'
    />
  </svg>
);

export const IconSun = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 0a1 1 0 011 1v2a1 1 0 11-2 0V1a1 1 0 011-1zm0 8a4 4 0 100 8 4 4 0 000-8zm-6 4a6 6 0 1112 0 6 6 0 01-12 0zm7 9a1 1 0 10-2 0v2a1 1 0 102 0v-2zM3.513 3.513a1 1 0 011.414 0l1.42 1.42a1 1 0 01-1.414 1.414l-1.42-1.42a1 1 0 010-1.414zm15.554 14.14a1 1 0 00-1.414 1.414l1.42 1.42a1 1 0 001.414-1.414l-1.42-1.42zM0 12a1 1 0 011-1h2a1 1 0 110 2H1a1 1 0 01-1-1zm21-1a1 1 0 100 2h2a1 1 0 100-2h-2zM6.347 17.653a1 1 0 010 1.414l-1.42 1.42a1 1 0 01-1.414-1.414l1.42-1.42a1 1 0 011.414 0zm14.14-12.726a1 1 0 00-1.414-1.414l-1.42 1.42a1 1 0 001.414 1.414l1.42-1.42z'
    />
  </svg>
);

export const IconTag = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23 2a1 1 0 00-1-1H12a1 1 0 00-.706.293L2.702 9.887a3 3 0 000 4.23l.002.002 7.17 7.17a3 3 0 004.244.001l8.589-8.58a1 1 0 00.293-.708V2zm-2 1v8.587l-8.297 8.29a1 1 0 01-1.414 0l-7.168-7.17H4.12a1 1 0 010-1.41L12.416 3H21zm-3 4a1 1 0 00-1-1h-.01a1 1 0 100 2H17a1 1 0 001-1z'
    />
  </svg>
);

export const IconTrash = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.293 3.293A1 1 0 0110 3h4a1 1 0 011 1v1H9V4a1 1 0 01.293-.707zM7 5V4a3 3 0 013-3h4a3 3 0 013 3v1h4a1 1 0 110 2h-1v13a3 3 0 01-3 3H7a3 3 0 01-3-3V7H3a1 1 0 010-2h4zM6 7v13a1 1 0 001 1h10a1 1 0 001-1V7H6zm4 3a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm5 7v-6a1 1 0 10-2 0v6a1 1 0 102 0z'
    />
  </svg>
);

export const IconTwitter = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path d='M23.954 4.569a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.691 8.094 4.066 6.13 1.64 3.161a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.061a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.937 4.937 0 004.604 3.417 9.868 9.868 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 002.46-2.548l-.047-.02z' />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconUpload = (
  <svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.29289 0.292893C9.68342 -0.0976311 10.3166 -0.0976311 10.7071 0.292893L15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711C15.3166 7.09763 14.6834 7.09763 14.2929 6.70711L11 3.41421V13.0714C11 13.5843 10.5523 14 10 14C9.44771 14 9 13.5843 9 13.0714V3.41421L5.70711 6.70711C5.31658 7.09763 4.68342 7.09763 4.29289 6.70711C3.90237 6.31658 3.90237 5.68342 4.29289 5.29289L9.29289 0.292893ZM1 12C1.55228 12 2 12.4477 2 13V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V17C20 17.7957 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7957 20 17 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.31607 18.5587 0 17.7957 0 17V13C0 12.4477 0.447715 12 1 12Z'
    />
  </svg>
);

export const IconUserGroup = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 7a3 3 0 116 0 3 3 0 01-6 0zm3-5a5 5 0 100 10A5 5 0 009 2zM5 14a5 5 0 00-5 5v2a1 1 0 001 1h16a1 1 0 001-1v-2a5 5 0 00-5-5H5zm-2.121 2.879A3 3 0 015 16h8a3 3 0 013 3v1H2v-1a3 3 0 01.879-2.121zm16.153-1.999a1 1 0 011.218-.718A5 5 0 0124 18.999V21a1 1 0 11-2 0v-2a3 3 0 00-2.25-2.902 1 1 0 01-.718-1.218zM16.248 2.161a1 1 0 10-.496 1.938 3 3 0 010 5.812 1 1 0 10.496 1.938 5 5 0 000-9.688z'
    />
  </svg>
);

export const IconUserOff = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g clipPath='url(#clip0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.707.293A1 1 0 00.293 1.707l7.025 7.025c.012.048.027.096.046.143a5.015 5.015 0 002.478 2.636.998.998 0 00.35.095L12.586 14H8a5 5 0 00-5 5v2a1 1 0 001 1h16c.17 0 .33-.042.47-.117l1.823 1.824a1 1 0 001.414-1.414l-22-22zM18.586 20l-4.004-4.003A1.019 1.019 0 0114.5 16H8a3 3 0 00-3 3v1h13.586zM12 4c-.896 0-1.7.391-2.25 1.016a1 1 0 11-1.5-1.324 5 5 0 116.875 7.21 1 1 0 11-1.25-1.56A3 3 0 0012 4z'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export const IconUser = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 7a3 3 0 116 0 3 3 0 01-6 0zm3-5a5 5 0 100 10 5 5 0 000-10zM8 14a5 5 0 00-5 5v2a1 1 0 001 1h16a1 1 0 001-1v-2a5 5 0 00-5-5H8zm-2.121 2.879A3 3 0 018 16h8a3 3 0 013 3v1H5v-1a3 3 0 01.879-2.121z'
    />
  </svg>
);

export const IconVisa = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path d='M17.445 8.623a4.991 4.991 0 00-1.74-.301c-1.92 0-3.275.968-3.285 2.355-.012 1.02.964 1.594 1.701 1.936.757.35 1.01.57 1.008.885-.005.477-.605.693-1.162.693-.766 0-1.186-.107-1.831-.375l-.239-.111-.271 1.598c.466.195 1.306.362 2.175.375 2.041 0 3.375-.961 3.391-2.439.016-.813-.51-1.43-1.621-1.938-.674-.33-1.094-.551-1.094-.886 0-.296.359-.612 1.109-.612a3.56 3.56 0 011.455.273l.18.081.271-1.544-.047.01zm4.983-.17h-1.5c-.467 0-.816.127-1.021.591l-2.885 6.534h2.041l.408-1.07 2.49.002c.061.25.24 1.068.24 1.068H24l-1.572-7.125zM9.66 8.393h1.943l-1.215 7.129H8.444L9.66 8.391v.002zm-4.939 3.929l.202.99 1.901-4.859h2.059l-3.061 7.115H3.768l-1.68-6.026a.398.398 0 00-.18-.237A8.211 8.211 0 000 8.598l.025-.15h3.131c.424.016.766.15.883.604l.682 3.273v-.003zm15.308.727l.775-1.994c-.01.02.16-.412.258-.68l.133.615.449 2.057h-1.615v.002z' />
    <defs>
      <linearGradient
        id='paint0_linear'
        x1='24'
        y1='8'
        x2='1'
        y2='8'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#002898' />
        <stop offset='1' stopColor='#11185C' />
      </linearGradient>
    </defs>
  </svg>
);

export const IconVolume2 = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.777 4.223a1 1 0 10-1.414 1.414 9 9 0 010 12.726 1 1 0 101.414 1.414 11 11 0 000-15.554zm-3.53 3.53a1 1 0 10-1.414 1.414 4 4 0 010 5.656 1 1 0 101.414 1.414 6 6 0 000-8.484zM12 5a1 1 0 00-1.625-.78L5.65 8H2a1 1 0 00-1 1v6a1 1 0 001 1h3.65l4.725 3.78A1 1 0 0012 19V5zM6.625 9.78L10 7.08v9.84l-3.375-2.7A1 1 0 006 14H3v-4h3a1 1 0 00.625-.22z'
    />
  </svg>
);

export const IconWallet = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.45 1.403A2 2 0 0118 3.326V5h2a2 2 0 012 2v12a2 2 0 01-2 2H3a1 1 0 01-1-1V6.754a2 2 0 011.45-1.923l12-3.428zM18 7v1h2V7h-2zm2 3h-2v5.246a2 2 0 01-1.45 1.923L10.14 19H20v-9zM4 18.674V6.754l12-3.428v11.92L4 18.674zM13 8a1 1 0 011 1v.05a1 1 0 11-2 0V9a1 1 0 011-1z'
    />
  </svg>
);

export const IconWaze = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path d='M13.609 1.265c-.475 0-.953.032-1.422.095a11.357 11.357 0 00-5.441 2.302C5.007 5.035 3.885 6.802 3.5 8.768c-.114.585-.163 1.232-.21 1.858-.074.979-.15 1.992-.462 2.653-.213.453-.53.754-1.389.754a1.246 1.246 0 00-.995 1.995c2.905 3.854 7.799 4.3 11.227 4.3l.253-.001H12.74c1.598 0 3.289-.079 4.83-.653a10.422 10.422 0 003.536-2.242c1.113-1.068 1.93-2.328 2.362-3.643.487-1.48.61-2.969.363-4.423a8.97 8.97 0 00-1.605-3.788c-.943-1.303-2.234-2.39-3.731-3.146a10.906 10.906 0 00-4.887-1.167zm0 1.246c5.613 0 10.61 5.011 8.677 10.889-.78 2.367-2.948 4.285-5.15 5.107-1.437.535-3.114.575-4.395.575l-.632-.001a29.748 29.748 0 00-.437 0c-3.218 0-7.66-.392-10.232-3.803 3.523 0 2.828-3.937 3.284-6.271.694-3.558 4.214-5.95 7.63-6.412.42-.057.84-.084 1.255-.084z' />
    <path d='M10.038 19.971a2.5 2.5 0 11-4.982.428 2.5 2.5 0 014.982-.428zm8.574 0a2.5 2.5 0 11-4.982.429 2.5 2.5 0 014.982-.428zM11.508 8.716a1.196 1.196 0 11-2.392 0 1.196 1.196 0 012.392 0zM17.222 8.53a1.196 1.196 0 11-2.393 0 1.196 1.196 0 012.393 0zM13.186 15.131a4.591 4.591 0 01-2.798-.94c-.803-.618-1.32-1.472-1.42-2.342a.623.623 0 011.237-.142c.152 1.327 1.738 2.213 3.072 2.177 1.7-.045 2.824-1.061 3.055-2.042a.624.624 0 011.212.285c-.188.8-.704 1.543-1.453 2.09-.779.57-1.74.885-2.78.913a5.68 5.68 0 01-.125.001z' />
  </svg>
);
